import { useEffect } from "react";
import styled from "styled-components";
import { handleHyperlinkValue } from "../../../../../utils/helpers";
import "./signature-product.component.scss";
const BackgroundType = {
  COLOR: 1,
  IMAGE: 2,
};

export function SignatureProduct(props) {
  const { config } = props;

  useEffect(() => {
    handleSeeMoreLessMore();
  }, []);

  const handleSeeMoreLessMore = () => {
    let seeMore = document.querySelectorAll(".signature-product-see-more");
    for (let i = 0; i < seeMore.length; i++) {
      seeMore[i].addEventListener("click", () => {
        seeMore[i].parentNode.classList.toggle("active");
      });
      var description = document.getElementById(`signature-product-description-${i}`);
      if (description.scrollHeight > description.clientHeight) {
        seeMore[i].classList.add("active");
      }
    }
  };

  const handleHyperlink = (hyperlinkType, hyperlinkValue) => {
    if (hyperlinkType) {
      window.location.href = handleHyperlinkValue(hyperlinkType, hyperlinkValue);
    }
  };

  const ProductCard = (props) => {
    const { index, title, description, buttonText, imageUrl, hyperlinkValue, hyperlinkType } = props;

    return (
      <div className="signature-product-container main-session">
        <div className="signature-product-image">
          <img src={imageUrl} />
        </div>
        <div className="signature-product-none"></div>
        <div className="signature-product-info">
          <h2 className="signature-product-title">{title}</h2>
          <p id={`signature-product-description-${index}`} className="signature-product-description">
            {description}
          </p>
          <a className="signature-product-see-more"></a>
          <div className="try-now-btn">
            <button className="signature-product-btn" onClick={() => handleHyperlink(hyperlinkType, hyperlinkValue)}>
              <span className="text-line-clamp-1">{buttonText}</span>
            </button>
          </div>
        </div>
      </div>
    );
  };

  const SignatureProductStyled = styled.div`
    #signature-product {
      display: ${props?.config?.signatureProduct?.visible ? "block" : "none"};
      background-color: ${(props) => {
        if (
          props.theme?.config?.signatureProduct?.generalCustomization?.backgroundType === BackgroundType.IMAGE ||
          props.theme?.config?.general?.generalBackground?.backgroundType === BackgroundType.IMAGE
        ) {
          return;
        }
        return (
          props.theme?.config?.signatureProduct?.generalCustomization?.backgroundColor ??
          props.theme?.config?.general?.generalBackground?.backgroundColor
        );
      }};
      background-image: ${(props) => {
        if (
          props.theme?.config?.signatureProduct?.generalCustomization?.backgroundType === BackgroundType.COLOR ||
          props.theme?.config?.general?.generalBackground?.backgroundType === BackgroundType.COLOR
        ) {
          return;
        }

        let image = `url(${props.theme?.config?.general?.generalBackground?.backgroundImage})`;
        image = `url(${props.theme?.config?.signatureProduct?.generalCustomization?.backgroundImage})`;
        if (props.theme?.config?.signatureProduct?.generalCustomization?.backgroundImage) {
          image = `url(${props.theme?.config?.signatureProduct?.generalCustomization?.backgroundImage})`;
        }

        return image;
      }};
      background-size: ${(props) => {
        if (
          props.theme?.config?.signatureProduct?.generalCustomization?.backgroundType === BackgroundType.COLOR ||
          props.theme?.config?.general?.generalBackground?.backgroundType === BackgroundType.COLOR
        ) {
          return;
        }
        return "100% 100%";
      }};
      background-repeat: ${(props) => {
        if (
          props.theme?.config?.signatureProduct?.generalCustomization?.backgroundType === BackgroundType.COLOR ||
          props.theme?.config?.general?.generalBackground?.backgroundType === BackgroundType.COLOR
        ) {
          return;
        }
        return "no-repeat";
      }};
      .signature-product-title {
        color: ${(props) => {
          const colorGroupId = props.theme?.config?.signatureProduct?.generalCustomization?.colorGroupId;
          if (colorGroupId) {
            const colorGroup = props.theme?.general.color.colorGroups?.find((i) => i.id === colorGroupId);
            return colorGroup?.titleColor;
          }
        }};
      }
      .signature-product-description {
        color: ${(props) => {
          const colorGroupId = props.theme?.config?.signatureProduct?.generalCustomization?.colorGroupId;
          if (colorGroupId) {
            const colorGroup = props.theme?.general.color.colorGroups?.find((i) => i.id === colorGroupId);
            return colorGroup?.textColor;
          }
        }};
      }
      .signature-product-btn {
        background: ${(props) => {
          const colorGroupId = props.theme?.config?.signatureProduct?.generalCustomization?.colorGroupId;
          if (colorGroupId) {
            const colorGroup = props.theme?.general.color.colorGroups?.find((i) => i.id === colorGroupId);
            return colorGroup?.buttonBackgroundColor;
          }
        }};
        border-color: ${(props) => {
          const colorGroupId = props.theme?.config?.signatureProduct?.generalCustomization?.colorGroupId;
          if (colorGroupId) {
            const colorGroup = props.theme?.general.color.colorGroups?.find((i) => i.id === colorGroupId);
            return colorGroup?.buttonBorderColor + " !important";
          }
        }};
        color: ${(props) => {
          const colorGroupId = props.theme?.config?.signatureProduct?.generalCustomization?.colorGroupId;
          if (colorGroupId) {
            const colorGroup = props.theme?.general.color.colorGroups?.find((i) => i.id === colorGroupId);
            return colorGroup?.buttonTextColor;
          }
        }};
      }
    }
  `;

  return (
    <>
      <SignatureProductStyled>
        <div id="signature-product">
          {config?.signatureProduct &&
            config?.signatureProduct?.signatureProducts?.length > 0 &&
            config?.signatureProduct?.signatureProducts?.map((item, index) => {
              return (
                <>
                  <ProductCard
                    index={index}
                    imageUrl={item?.thumbnail}
                    title={item?.nameCategory}
                    description={item?.textArea}
                    buttonText={item?.buttonText}
                    hyperlinkValue={item?.hyperlinkValue}
                    hyperlinkType={item?.hyperlinkType}
                  />
                </>
              );
            })}
        </div>
      </SignatureProductStyled>
    </>
  );
}
